import Immutable from 'immutable';
import { createReducer } from '../utils';

const initialUser = Immutable.fromJS({
  settings: {},
});

export default createReducer(initialUser, {});



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js